import { render } from "./LocalizedText.vue?vue&type=template&id=638e5434&scoped=true"
import script from "./LocalizedText.vue?vue&type=script&lang=js"
export * from "./LocalizedText.vue?vue&type=script&lang=js"

import "./LocalizedText.vue?vue&type=style&index=0&id=638e5434&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-638e5434"]])

export default __exports__